export default __webpack_public_path__ + "static/media/warning-mark.288d7f3d.svg";